import { FETCH_POSTS, FETCH_DATA } from '../actions/type';

const initialState = {
    items: [],
    fetch_data:[]
}

export default function(state = initialState, action) {
    switch (action.type) {
        case FETCH_POSTS:
            return {
                ...state,
                items:action.payload
            };
        case FETCH_DATA:
            return {
                ...state,
                fetch_data:action.payload
        };
        default:
            return state;
    }
}